import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { easeExpIn } from 'd3';
import { MessageService } from 'primeng/api';
import { link, stat } from 'src/app/admin/layout/header/header.component';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-update-dates',
  templateUrl: './update-dates.component.html',
  styleUrl: './update-dates.component.scss'
})
export class UpdateDatesComponent implements OnInit, OnChanges {
  header = this.translate('Training Dates');

  @Output() updatedData: EventEmitter<any> = new EventEmitter()
  @Input() courseId: string = '66bf2c4acbc74514c23ee276';
  courseData: any;
  sessions: any[] = []
  today: Date = this.removeTimeFromDate(new Date())
  locations: Array<Location | any> = [];
  skelition: boolean = true;
  currentSession: any;
  showInternal: boolean = false;
  internalTrainers: any[] = [];
  externalTrainers: any[] = [];
  addTrainerModal: boolean = false;
  updateTrainer: boolean = false;


  constructor(
    private dataService: DataService,
    private messageService: MessageService,
    public permissionService: PermissionHandlerService,

  ) { }

  ngOnInit(): void {
    Promise.all([this.getCity(), this.getCourseData(), this.getInternalTrainers()]).then(e => {
      this.skelition = false;
      this.validateDates(this.courseData.start_date, this.courseData.end_date)
    })
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['courseId']) {
      this.courseData = undefined
      this.skelition = true
      Promise.all([this.getCourseData()]).then(e => {
        this.skelition = false;
        this.validateDates(this.courseData.start_date, this.courseData.end_date)
      })
    }
  }

  validateDates(start: Date, end: Date) {
    if (!!start && !!end) {
      let startDate: Date = this.removeTimeFromDate(start)
      let endDate: Date = this.removeTimeFromDate(end)

      if (start.getTime() < this.today.getTime()) {
        this.courseData.start_date = null;
      }

      if (end.getTime() < this.today.getTime()) {
        this.courseData.end_date = null;
      }

      if (start.getTime() > end.getTime()) {
        this.courseData.end_date = null;
      }

      this.sessions = this.sessions.map((session: any) => {
        let sessionDate = this.removeTimeFromDate(new Date(session.date));
        let sDate = sessionDate.getTime()
        if (!this.courseData.start_date || !this.courseData.end_date) {
          session.date = null;
          return session;
        }
        if (!(sDate >= startDate.getTime() && sDate <= endDate.getTime())) {
          session.date = null;
        }
        return session;
      })
    }
  }



  disableDates(values: any) {
    let selectedDate = new Date(values.year, values.month, values.day, 0, 0, 0)

    const startDate = this.courseData.start_date;
    const endDate = this.courseData.end_date;
    return !((selectedDate.getTime() >= startDate.getTime()) && (selectedDate.getTime() <= endDate.getTime()));
  }

  disableCourseDates(values: any, position: string) {
    let date = new Date(values.year, values.month, values.day, 0, 0, 0)

    if (position == 'START') {
      console.log('TODAY', this.today, date, date.getTime() < this.today.getTime(), date.getTime(), this.today.getTime())
      return date.getTime() < this.today.getTime();
    } else if (position == 'END') {
      return date.getTime() < this.removeTimeFromDate(this.courseData?.start_date)?.getTime()
    }
    return false;
  }

  removeTimeFromDate(date: Date) {
    date?.setHours(0);
    date?.setMinutes(0);
    date?.setSeconds(0);
    date?.setMilliseconds(0)
    return date;
  }

  private translate(text: string) {
    return new TranslatorPipe().transform(text);
  }

  internalExternal(type: any) {
    this.showInternal = !(type.checked == true)
  }

  handleUpdatedUserData(event: any) {
    this.getInternalTrainers()
  }

  //get internal trainners
  getInternalTrainers = async () => {
    try {
      let query: any = {
        'externalUser.role': 'trainer'
      }

      let res = await this.dataService.postData('user/get', query);
      if (res.error) return

      res?.data.forEach((item: any) => {
        let trainer = {
          name: `${item?.name?.first}  ${item?.name?.middle} ${item?.name?.last}`,
          user_id: item._id,
          company_id: item?.externalUser?.company?._id,
          email: item?.email
        }
        if (!!item.externalUser.status) {
          this.externalTrainers.push(trainer)
        } else {
          this.internalTrainers.push(trainer)
        }
      });

    } catch (error) {
      console.log(error)
    }
  }


  async assNewTrainers(list : any){
    if(list.emit == false){
      this.addTrainerModal = false
    }
    const arrayOfIds = list.users.map((obj:any) => obj._id);
    try {
      let res :any = await this.dataService.postData('user/add-trainer',arrayOfIds,'PUT',false);
      if(res.error) {
        return
      }  
      else {
        this.addTrainerModal = false
        this.getInternalTrainers();
      }
    } catch (error) {
      console.log(error)
    }
  }


  async getCourseData() {
    if (!!this.courseId) {
      try {
        const res = await this.dataService.getData(`course/id/${this.courseId}`);
        if (res.error) {
          console.log(res.msg);
          return;
        }
        this.courseData = res.data[0];
        if (!!this.courseData) {
          if (!!this.courseData.start_date) {
            this.courseData.start_date = new Date(this.courseData.start_date)
          }
          if (!!this.courseData.end_date) {
            this.courseData.end_date = new Date(this.courseData.end_date)
          }
          this.sessions = this.courseData.session
            .filter((e: any) => e.sessionType == 'Online' || e.sessionType == 'Onsite')
            .sort((a: any, b: any) => a.order - b.order)
            .map((e: any) => {
              e.date = new Date(e.date)
              return e;
            })

          this.sessions.map((e: any) => { this.checkTrainerAvailability(e) })

        }
      } catch (e: any) {
        console.log(e)
      }
    }
  }

  resetTrainer(obj: any, field: string, index: number) {
    let session: any = this.sessions[index];
    if (field == 'DATE') {
      session.date = obj;
    } else if (field == 'STIME') {
      session.start_time = obj;
    } else if (field == 'ETIME') {
      session.end_time = obj;
    }
    session.trainer = null;
    //two sessions date and time should not be same
    let exists = this.sessions.find((e, i) => {
      if (i == index) {
        return false;
      }
      console.log('CONDITION', obj, field, session)
      return this.compareDateTime(session, e);
    });
    console.log('CONDITION EXISTS', exists)
    if (!!exists) {
      session.date = null
      session.start_time = null;
      session.end_time = null;
    }
  }

  compareDateTime(session: any, current: any) {
    return session?.date?.getTime() == current?.date?.getTime() &&
      session?.start_time == current.start_time &&
      session?.end_time == current?.end_time;
  }

  async getCity() {
    try {
      let res = await this.dataService.getData('location');
      if (!res.error) {
        this.locations = res.data.map((location: any) => {
          return {
            value: location.name,
            label: location.name,
            icon: 'pi pi-map-marker',
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  changeSession(session: any) {
    this.currentSession = session;
  }

  saveData(form: NgForm) {

    if (!form.valid) {
      return;
    }

    let data = {
      start_date: this.courseData.start_date,
      end_date: this.courseData.end_date,
      title: this.courseData.title,
      description: this.courseData.description,

      sessions: this.sessions.map(e => {
        let data: any = {
          ...e,
          trainer: e.trainer,
          date: e.date,
          start_time: e.start_time,
          end_time: e.end_time,
          title: e.title
        }
        if (e.sessionType == 'Online') {
          data = {
            ...data,
            zoom_url: e.zoom_url
          }
        } else if (e.sessionType == 'Onsite') {
          data = {
            ...data,
            address: e.address,
            locationLink: e.locationLink,
            city: e.city
          }
        }
        return data;
      })
    }
    this.updatedData.emit(data);
  }

  hasPermission(unit:string,flag:string){
    return this.permissionService.hasPermission(unit, flag)
  }
  
  validateFormField(courseForm: NgForm, field: string) {
    return courseForm.submitted && courseForm.controls[field]?.invalid
  }


  updateTrainerSection(event: any, sessionData: any) {
    event.stopPropagation()
    sessionData.trainer = null
    this.updateTrainer = !this.updateTrainer

   //debugger
  }


  trainerErrors: any = {
    requestError: false,
    availabilityError: false
  }

  checkTrainerAvailability = async (sessionData: any) => {
    try {

      this.trainerErrors = {
        requestError: false,
        availabilityError: false
      }

      if (sessionData.sessionType == 'Video') {
        return
      }

      // let sessionData = this.sessionForm.getRawValue()

      if (!sessionData.trainer.user_id || !sessionData.end_time || !sessionData.start_time || !sessionData.date) {
        sessionData.trainer = null
        this.trainerErrors.requestError = true
        return
      }

      let query: any = {
        trainerId: sessionData.trainer.user_id,
        date: sessionData.date,
        start_time: sessionData.start_time,
        end_time: sessionData.end_time
      }

      // if (!!sessionData?._id) {
      //   query.sessionId = sessionData._id
      // }

      let res = await this.dataService.postData('session/check-trainer-availability', query)
      if (res.error) {
        sessionData.trainer = null
        return
      }
      if (res.data[0]?.busy) {
        sessionData.trainer = null
        this.trainerErrors.availabilityError = true
      }

      return

    } catch (error) {
      console.log(error)
    }
  };


}
